'use client';

// ── Trading Commission · "How it works" ───────────────────────────────────────
// Figma "Moldura · Como funciona": desktop 12071:59952 (792×290), mobile
// 12471:8982 (366×614). Every size is Figma px / 8 in rem. Three step cards
// (open → hold → close) joined by 16px Carbon arrows (right on desktop, down on
// mobile) and a bordered "total" row that stacks on mobile. Values are
// illustrative; the page note says so.

import { cn } from '@/lib/utils';
import { ArrowRightIcon } from '../Icons';
import { ExampleLabel, FigureFrame } from '../primitives';

const STEPS = [
  { label: '1 · OPEN', title: 'You open a trade', chip: '− commission', tone: 'red' },
  { label: '2 · HOLD', title: 'Your position runs', chip: 'no commission', tone: 'neutral' },
  { label: '3 · CLOSE', title: 'You close the trade', chip: '− commission', tone: 'red' },
] as const;

const TEXT = 'mb-0 whitespace-nowrap text-[2rem] leading-[3rem]';

export default function TradingCommission() {
  return (
    <FigureFrame data-ui="figure.tradingCommission" padding="p-[2rem] lg:p-[3rem]" className="gap-[2.5rem] font-geist">
      <ExampleLabel>HOW IT WORKS</ExampleLabel>

      {/* Etapas */}
      <div
        data-ui="figure.tradingCommission.steps"
        className="flex w-full flex-col items-center gap-[1rem] lg:flex-row lg:items-center"
      >
        {STEPS.map((step, i) => (
          <div key={step.label} className="contents">
            {i > 0 && (
              <div className="flex h-[2rem] w-[2rem] shrink-0 items-center justify-center text-black/[0.32]">
                <ArrowRightIcon className="h-[2rem] w-[2rem] rotate-90 lg:rotate-0" />
              </div>
            )}
            <div
              data-ui="figure.tradingCommission.step"
              className="flex h-[15.5rem] w-full min-w-0 flex-col items-start gap-[1rem] rounded-[0.25rem] bg-[#f2f4f3] p-[2rem] lg:w-auto lg:flex-1"
            >
              <p className={`${TEXT} font-medium text-black/40`}>{step.label}</p>
              <p className={`${TEXT} font-medium text-black`}>{step.title}</p>
              <div
                className={cn(
                  'inline-flex items-center rounded-[0.25rem] px-[1.25rem] py-[0.25rem]',
                  step.tone === 'red' ? 'bg-[#ac0003]/[0.08] text-[#ac0003]' : 'bg-black/[0.06] text-black',
                )}
              >
                <p className={`${TEXT} font-medium`}>{step.chip}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Total */}
      <div
        data-ui="figure.tradingCommission.total"
        className="flex w-full flex-col gap-[0.5rem] rounded-[0.25rem] border border-black/10 px-[2rem] py-[1.75rem] lg:h-[6.75rem] lg:flex-row lg:items-center lg:justify-between lg:gap-0"
      >
        <p className={`${TEXT} font-normal text-black/[0.64]`}>Total cost of one trade</p>
        <p className={`${TEXT} font-medium text-black`}>2 × commission</p>
      </div>
    </FigureFrame>
  );
}
